import React, { useMemo } from 'react';
import { buildCreditReportDateLabels } from '../../utils/creditReportDates';

/**
 * Compact stacked date lines for bureau cards and summary areas.
 */
const ReportDateLines = ({
  report,
  bureauName = null,
  t,
  theme,
  className = '',
  align = 'center',
  showReportDate = true,
  showImported = true,
  testId,
}) => {
  const dates = useMemo(
    () => buildCreditReportDateLabels(report, { bureauName, t }),
    [report, bureauName, t],
  );

  if (!showReportDate && !showImported) return null;

  const alignClass = align === 'left' ? 'items-start text-left' : 'items-center text-center';

  return (
    <div
      className={`flex flex-col gap-0.5 w-full ${alignClass} ${className}`}
      data-testid={testId}
    >
      {showReportDate ? (
        <span className="text-[10px] leading-snug" style={{ color: theme?.text?.muted }}>
          {dates.reportDateLine}
        </span>
      ) : null}
      {showImported && dates.importedLine ? (
        <span className="text-[10px] leading-snug" style={{ color: theme?.text?.muted }}>
          {dates.importedLine}
        </span>
      ) : null}
    </div>
  );
};

export default ReportDateLines;
